/**
 * Bottom-right canvas tray control: one click runs Macro Graph AI Summary
 * on the whole canvas (no node pick required). Workbench opens the Node
 * Inspector to the result when generation finishes.
 */
import React from 'react';
import { Loader2, ScanLine } from 'lucide-react';

export interface GraphSummaryTrayButtonProps {
    onClick: () => void;
    loading?: boolean;
    disabled?: boolean;
}

export function GraphSummaryTrayButton({
    onClick,
    loading = false,
    disabled = false,
}: GraphSummaryTrayButtonProps) {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled || loading}
            className={`p-1.5 rounded-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ${
                loading
                    ? 'bg-primary/15 text-primary border border-primary/40'
                    : 'hover:bg-muted text-muted-foreground hover:text-primary border border-transparent hover:border-border bg-card/80 backdrop-blur-md disabled:opacity-50 disabled:pointer-events-none'
            }`}
            title="Generate AI graph summary for the whole canvas"
            aria-label="Generate AI graph summary"
            aria-busy={loading || undefined}
            data-tour="canvas-graph-summary"
            data-testid="wb-graph-summary-btn"
        >
            {loading ? (
                <Loader2 className="w-4 h-4 animate-spin" aria-hidden />
            ) : (
                <ScanLine className="w-4 h-4" aria-hidden />
            )}
        </button>
    );
}
